import { useEstadoConexion } from '../../nucleo/red/useEstadoConexion';

/**
 * Permanente y sin animacion: nunca un girito que se cuelga sin decir que paso. La
 * decision mas importante de este componente es que el texto explica la CONSECUENCIA
 * ("no se puede guardar") y no el diagnostico tecnico ("sin red"), porque a las 3 de la
 * mañana el operario necesita saber si puede seguir, no depurar su router.
 */
export function IndicadorConexion({
  idPrueba = 'indicador-conexion',
  enMarco = false,
}: {
  idPrueba?: string;
  enMarco?: boolean;
}) {
  const { enLinea, fallosSeguidos } = useEstadoConexion();
  // EL DE LA PANTALLA SÓLO SE VE CUANDO HAY ALGO QUE DECIR. El marco ya muestra «En línea» siempre,
  // y el de cada pantalla lo repetía debajo, dos veces en el teléfono: revisión de experiencia del
  // 2026-09-28. Sigue en el documento para el lector de pantalla y las pruebas, y aparece junto al
  // botón en cuanto se cae la red, que es cuando importa.
  const oculto = !enMarco && enLinea && fallosSeguidos === 0;
  return (
    <div
      data-testid={idPrueba}
      className={oculto ? 'sr-only' : 'inline-flex items-center gap-1.5 text-[12.5px]'}
    >
      {/* El punto acompaña al texto y no lo reemplaza: con la luz roja del bar el verde y el
          coral se confunden, y la palabra no. */}
      <span
        aria-hidden
        className={`inline-block size-2 shrink-0 rounded-full ${enLinea ? 'bg-[#5FA865]' : 'bg-coral'}`}
      />
      {enLinea ? 'En línea' : 'Sin conexión: no se puede guardar'}
      {fallosSeguidos > 0 && (
        <span data-testid="fallos-red">
          {', '}
          {fallosSeguidos} intento{fallosSeguidos === 1 ? '' : 's'} sin conexión
        </span>
      )}
    </div>
  );
}

/**
 * Texto que acompaña un boton deshabilitado por falta de conexion. Un solo lugar para no
 * tener dos redacciones distintas de la misma razon en dos pantallas.
 */
export function razonSinConexion(
  accion:
    | 'el conteo'
    | 'el cierre'
    | 'la asignación del faltante'
    | 'la reposición'
    | 'el egreso'
    | 'la cortesía'
    // La séptima entra con la pantalla del personal del turno, fase 9 tarea 16. La unión está
    // cerrada para que no haya dos redacciones de la misma razón, no por gramática: cada acción
    // nueva que se pueda bloquear por falta de conexión agrega la suya acá y no inventa su frase
    // en la pantalla. Usar una de las otras seis habría dicho algo falso a las 3 de la mañana.
    | 'el registro del personal'
    // Las dos de la noche, que entraron el 2026-09-28 con sus pantallas.
    | 'las ventas'
    | 'las propinas'
    | 'el traslado'
    | 'el reparto'
    | 'el pago del impuesto'
    | 'la comisión'
    | 'las horas'
    | 'la nómina'
    | 'la reapertura'
    | 'el descarte'
    | 'la marca de dueño'
    | 'el saldo de apertura'
    | 'el contraasiento'
    | 'el registro de la factura'
    | 'el pago del gasto fijo'
    | 'la compra'
    | 'la corrección'
    | 'la autorización'
    | 'la categoría'
    | 'el ítem'
    | 'la salida de inventario'
    | 'la receta'
    | 'el socio'
    | 'el cambio de rol',
): string {
  return `Sin conexión: no se puede guardar ${accion}`;
}
